// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__DOJDs","large":"styles_large__1JdZz"};